import { FC, ReactNode } from 'react';

interface PageHeaderProps {
  title: string;
  description?: ReactNode;
  badge?: {
    text: string;
    bgColor?: string;
    textColor?: string;
  };
  actions?: ReactNode;
}

export const PageHeader: FC<PageHeaderProps> = ({ title, description, badge, actions }) => {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex justify-between items-start">
        <div className="flex flex-col gap-2">
          {badge && (
            <span
              className="inline-flex items-center px-3 py-1 rounded-full! text-[14px] font-semibold w-fit"
              style={{
                backgroundColor: badge.bgColor || 'var(--tertiary-Y100)',
                color: badge.textColor || 'var(--secondary-B700)',
              }}
            >
              {badge.text}
            </span>
          )}
          <h1 className="[font-size:var(--fs-h5)]! lg:[font-size:var(--fs-h2)]! text-(--neutral-black-NB1000)! leading-tight font-bold m-0!">
            {title}
          </h1>
          {description && (
            <p className="[font-size:var(--fs-p3)]! text-(--neutral-black-NB900)! leading-tight m-0!">
              {description}
            </p>
          )}
        </div>
        {actions && <div className="flex items-center gap-2">{actions}</div>}
      </div>
    </div>
  );
};
